import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/cwd/frontend_projects/cwd-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cwd/frontend_projects/cwd-website/src/components/Contact/ContactCards/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cwd/frontend_projects/cwd-website/src/components/Contact/LocationSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cwd/frontend_projects/cwd-website/src/components/Contact/MapSection/index.tsx");
